import React from 'react'

function Service1() {
    return (
        <>
            <h1>Hello Ooty</h1>
        </>
    )
}

export default Service1
